import { useCallStore } from '@/stores/call';
import { useUserStore } from '@/stores/user';
import redirectToLoginPage from '@/utils/redirectToLoginPage';

export function useAccount() {
  const userStore = useUserStore();
  const callStore = useCallStore();

  // 로그아웃 하고 로그인 페이지로 이동
  const logoutAndGoToLogin = async () => {
    await userStore.requestLogout();
    const paramsUrl = new URLSearchParams();
    const partnerCode = callStore.qrCodeInfo.partnerCode;
    const partnerType = callStore.qrCodeInfo.partnerType;
    if (partnerCode) {
      paramsUrl.set('partnerCode', partnerCode);
    }
    const queryString = decodeURIComponent(paramsUrl.toString());
    const afterLoginPath = queryString ? `${location.pathname}?${queryString}` : location.pathname;

    redirectToLoginPage(afterLoginPath, partnerType);
  };

  return { logoutAndGoToLogin };
}
